import { ShoppingListProductDto, ShoppingListDto, ShoppingListGroupDto, ShoppingListCommentDto } from '@api/*';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ShoppingListActions = createActionGroup({
    source: 'ShoppingList',
    events: {
        'Get All Shopping Lists': emptyProps(),
        'Get All Shopping Lists Success': props<{ shoppingLists: ShoppingListDto[] }>(),
        'Get All Shopping Lists Failure': props<{ error: string }>(),

        'Get Shopping List': props<{ shoppingListId: number }>(),
        'Get Shopping List Success': props<{ shoppingList: ShoppingListDto }>(),
        'Get Shopping List Failure': props<{ error: string }>(),

        'Create Shopping List': props<{ name: string }>(),
        'Create Shopping List Success': props<{ shoppingList: ShoppingListDto }>(),
        'Create Shopping List Failure': props<{ error: string }>(),

        'Update Shopping List Name': props<{ shoppingListId: number; name: string }>(),
        'Update Shopping List Name Success': props<{ shoppingList: ShoppingListDto }>(),
        'Update Shopping List Name Failure': props<{ error: string }>(),

        'Delete Shopping List': props<{ shoppingListId: number }>(),
        'Delete Shopping List Success': props<{ shoppingListId: number }>(),
        'Delete Shopping List Failure': props<{ error: string }>(),

        'Add Group to Shopping List': props<{ shoppingListId: number; groupName: string }>(),
        'Add Group to Shopping List Success': props<{ shoppingListId: number; shoppingListGroup: ShoppingListGroupDto }>(),
        'Add Group to Shopping List Failure': props<{ error: string }>(),

        'Update Shopping List Group Name': props<{ shoppingListGroupId: number; name: string }>(),
        'Update Shopping List Group Name Success': props<{ shoppingListGroup: ShoppingListGroupDto }>(),
        'Update Shopping List Group Name Failure': props<{ error: string }>(),

        'Remove Group from Shopping List': props<{ shoppingListGroupId: number }>(),
        'Remove Group from Shopping List Success': props<{ shoppingListGroupId: number }>(),
        'Remove Group from Shopping List Failure': props<{ error: string }>(),

        'Add Product to Shopping List': props<{
            shoppingListId: number;
            productId: number;
            quantity: number;
            shoppingListGroupId?: number;
        }>(),
        'Add Product to Shopping List Success': props<{ shoppingList: ShoppingListDto }>(),
        'Add Product to Shopping List Failure': props<{ error: string }>(),

        'Create Shopping List And Add Product': props<{ name: string; productId: number; quantity: number }>(),
        'Create Shopping List And Add Product Success': props<{ shoppingList: ShoppingListDto }>(),
        'Create Shopping List And Add Product Failure': props<{ error: string }>(),

        'Update Product Quantity in Shopping List': props<{ shoppingListProductId: number; quantity: number; showMessage?: boolean }>(),
        'Update Product Quantity in Shopping List Success': props<{ shoppingListProduct: ShoppingListProductDto; showMessage?: boolean }>(),
        'Update Product Quantity in Shopping List Failure': props<{ error: string }>(),

        'Remove Product from Shopping List': props<{ shoppingListProductId: number }>(),
        'Remove Product from Shopping List Success': props<{ shoppingListProductId: number }>(),
        'Remove Product from Shopping List Failure': props<{ error: string }>(),

        'Add Comment to Shopping List': props<{ shoppingListId: number; shoppingListProductId: number; text: string }>(),
        'Add Comment to Shopping List Success': props<{ shoppingListComment: ShoppingListCommentDto }>(),
        'Add Comment to Shopping List Failure': props<{ error: string }>(),

        'Update Comment in Shopping List': props<{ shoppingListCommentId: number; text: string }>(),
        'Update Comment in Shopping List Success': props<{ shoppingListComment: ShoppingListCommentDto }>(),
        'Update Comment in Shopping List Failure': props<{ error: string }>(),

        'Remove Comment from Shopping List': props<{ shoppingListCommentId: number }>(),
        'Remove Comment from Shopping List Success': props<{ shoppingListCommentId: number }>(),
        'Remove Comment from Shopping List Failure': props<{ error: string }>(),
    },
});
